import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { CONTENT } from "./content";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang] = useState("en");

  useEffect(() => {
    document.documentElement.lang = "en";
    document.title = "The Things We Keep — Objects with a story";
  }, []);

  const value = useMemo(() => ({ lang, setLang: () => {}, t: CONTENT[lang] }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
